const URL_AJAX_PV = '/ajax/pv';
const COOKIE_SESSION_ID = 'PHPSESSID';

const preMatomoQueue = [];

window.addEventListener("ucEvent", e => {
    if (e.detail && e.detail.event === "consent_status") {
        const matomoEnabled = e.detail["Matomo (self hosted)"];
        window.sds_matomo = !!matomoEnabled;

        if (matomoEnabled) {
            while (preMatomoQueue.length > 0) {
                const next = preMatomoQueue.shift();
                sendAjaxMatomoPV(next);
            }
        }

        preMatomoQueue.length = 0;
    }
});

/**
 * @param {object} pv
 */
function whenMatomoConsent(pv) {
    if (typeof window.sds_matomo === 'boolean') {
        if (!window.sds_matomo) return;  // no consent

        sendAjaxMatomoPV(pv);
    } else {
        // no consent status yet, enqueue page view
        preMatomoQueue.push(pv);
    }
}

/**
 * @param {object} pv The page view object.
 */
function sendAjaxMatomoPV(pv) {
    const query = Object.entries(pv)
        .map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value))
        .join('&');

    fetch(URL_AJAX_PV + '?' + query)
        .catch(() => console.warn('[MatomoTracking] error during response'));
}

/**
 * Track a virtual Matomo page view.
 * @param {string} url The url to track.
 * @param {string} title The title of the document.
 */
export function trackMatomoPageView(url, title) {
    if (typeof SDS !== 'object' || typeof SDS.Utils !== 'object' || typeof SDS.Utils.trackPageView !== 'function') {
        console.warn("[MatomoTracking] Matomo is not initialized")
        return;
    }

    try {
        new URL(url);
    } catch (e) {
        return console.warn("[MatomoTracking] invalid url supplied")
    }

    SDS.Utils.trackPageView(url, title);

    const sessionId = findSessionId();
    if (!sessionId)
        return console.warn('[MatomoTracking] could not find current session cookie')

    whenMatomoConsent({
        u: url,
        s: sessionId,  // cookie value
        t: title
    });
}

/**
 * Track a virtual Google Analytics page view.
 * @param url The url to track.
 * @param title The title of the document.
 */
export function trackGaPageView(url, title) {
    let parsedUrl = null;
    try {
        parsedUrl = new URL(url);
    } catch (e) {
        return console.warn("[GoogleAnalytics] invalid url supplied")
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'virtual_page_view',
        'page_path': parsedUrl.pathname,
        'page_location': url,
        'page_title': title
    });
}

/**
 * Fetches the current session id from cookies.
 * @returns {string|null} The session id, or null if none was found.
 */
export function findSessionId() {
    const sessionCookie = document.cookie.split(';')
        .map(el => {
            const [key, ...rest] = el.split('=');
            return [key.trim(), ...rest];
        })
        .find(([key]) => key === COOKIE_SESSION_ID);

    return sessionCookie ? sessionCookie[1] : null;
}


/**
 * Add infos from form action to datalayer
 * @param key Key of the Event
 * @param value Value of the Event
 * */
export function addFormDataToLayer(key, value) {
    if (key.length && value.length) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'collect_data',
            [key]:value
        });
    }
}


